import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    searchedPin: String(''),
    selectedCustomerId: Number(),
    dealerSearchData: {},
    machines: [],
    machinesOfCustomer: [],
    machine: null,
    selectedDealerId: String(''),
    selectedModel: String(''),
    machinesOfDealer: [],
    pageData: {
        pageNumber: 1,
        pageSize: 200,
        count: 200,
        hasMore: false,
        totalRecords: 0
    },
    loading: false,
    machineSearchError: null,
    dealerSearchError: null,
    customerSearchError: null

}

export const getMachines = createAsyncThunk(
    'machineList/getMachines',
    async (searchObject) => {

        let machineSearchApiUrl;
        const oktaTokenStorage = JSON.parse(sessionStorage.getItem("okta-token-storage"));
        const userId = oktaTokenStorage?.accessToken?.claims?.userID;

        const params = {
            serialNumber: searchObject.searchedPin,
            userId: userId,
            pageSize: searchObject.pageSize ?? 200,
            pageNumber: searchObject.pageNumber ?? 1
        }

        if (searchObject.searchType === "completePin") {
            machineSearchApiUrl = "/machine-search/product-details-complete-pin"
        } else {
            machineSearchApiUrl = "/machine-search/partial-pin"
        }

        try {
            const response = await wtyReportApi.get(machineSearchApiUrl, params);
            if (response.status !== 200) {
                throw new Error("Calling machine list api to get machine for serial number failed.")
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    });

export const getMachineDetails = createAsyncThunk(
    "machineList/getMachineDetails", async (pin) => {
        let machineSearchApiUrl = "/machine-search/product-details-complete-pin";
        const oktaTokenStorage = JSON.parse(sessionStorage.getItem("okta-token-storage"));
        const userId = oktaTokenStorage?.accessToken?.claims?.userID;
        const userType = oktaTokenStorage?.idToken?.claims?.userType;
        let params;
        if (userType.includes("Dealer")) {
            params = {
                serialNumber: pin
            };
            machineSearchApiUrl = machineSearchApiUrl + "-dealer";
        } else {
            params = {
                serialNumber: pin,
                userId: userId
            };
        }

        try {
            const response = await wtyReportApi.get(machineSearchApiUrl, params);
            if (response.status !== 200) {
                throw new Error("Calling machineDetails api to get machineDetails failed");
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    });

/*export const getProductDetails = createAsyncThunk(
    "machineSearch/getProductDetails",
    async ({PIN}) => {

    }
);*/

export const getMachinesForCustomer = createAsyncThunk(
    "machineList/getMachinesForCustomer",
    async ({entityId, pageSize, pageNumber, dealerId}) => {

        const params = {
            entityId: entityId,
            dealerId: dealerId,
            pageSize: pageSize ?? 200,
            pageNumber: pageNumber ?? 1
        }

        const machineSearchApiUrl = "/machine-search/customer-machines";
        try {
            const response = await wtyReportApi.get(machineSearchApiUrl, params);
            if (response.status !== 200) {
                throw new Error("Calling machine list api to get machine for a customer failed.")
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const getSecurityFeatureAccess= createAsyncThunk(
    "security/hasFeatureAccess",
    async ({userId}) => {

        const securityAccess = `/security/${userId}`;
        try {
            const response = await wtyReportApi.get(securityAccess);
            if (response.status !== 200) {
                throw new Error("Calling security api to check feature access failed.")
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const getMachinesForDealer = createAsyncThunk(
    "machineList/getMachinesForDealer",
    async ({dealerQueryObj, pageSize, pageNumber}) => {

        const machineSearchApiUrl = "/machine-search/dealer-machines?pageNumber=" + pageNumber + "&pageSize=" + pageSize;

        try {
            const response = await wtyReportApi.post(machineSearchApiUrl, dealerQueryObj);

            if (response.status !== 200) {
                throw new Error("Calling machine list api to get machine for a dealer failed.")
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }
);

const machineListSlice = createSlice({
    name: "machineList",
    initialState,
    reducers: {
        setSearchedPin: (state, action) => {
            state.searchedPin = action.payload;
        },
        setDealerSearchData: (state, action) => {
            state.dealerSearchData = action.payload;
        },
        resetMachineState: (state) => {
            state.searchedPin = initialState.searchedPin;
            state.selectedCustomerId = initialState.selectedCustomerId;
            state.dealerSearchData = initialState.dealerSearchData;
            state.machines = initialState.machines;
            state.machinesOfCustomer = initialState.machinesOfCustomer;
            state.machine = initialState.machine;
            state.selectedDealerId = initialState.selectedDealerId;
            state.selectedModel = initialState.selectedModel;
            state.machinesOfDealer = initialState.machinesOfDealer;
            state.pageData = initialState.pageData;
            //state.loading = initialState.loading;
            state.machineSearchError = initialState.machineSearchError;
            state.dealerSearchError = initialState.dealerSearchError;
            state.customerSearchError = initialState.customerSearchError;
        },
        resetMachineDetails: state => {
            state.machine = initialState.machine;
        },
        resetMachineError: (state) => {
            state.machineSearchError = initialState.machineSearchError;
          },
    },
    extraReducers(builder) {
        builder
            .addCase(getMachines.pending, (state) => {
                state.loading = true;
                state.machines = [];
                state.machineSearchError = undefined;
                state.pageData.totalRecords = 0;
            })
            .addCase(getMachines.rejected, (state, action) => {
                state.loading = false;
                state.machineSearchError = action.error;
                state.pageData.totalRecords = 0;
            })
            .addCase(getMachines.fulfilled, (state, action) => {
                state.loading = false;
                state.machines = action.payload;
                /*Setting pagination data*/
                state.pageData.pageNumber = action.payload?.pageNumber;
                state.pageData.pageSize = action.payload?.pageSize;
                state.pageData.count = action.payload?.count;
                state.pageData.hasMore = action.payload?.hasMore;
                state.pageData.totalRecords = action.payload?.totalRecords;
                state.machineSearchError = undefined;
            })
            .addCase(getMachineDetails.pending, state => {
                state.loading = true;
                state.machine = null;
                state.machineSearchError = undefined;
            })
            .addCase(getMachineDetails.rejected, (state, action) => {
                state.loading = false;
                state.machineSearchError = action.error;
            })
            .addCase(getMachineDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.machine = action.payload;
                if (!action.payload) {
                    state.machineSearchError =
                      "No machines found for this criteria.";
                      state.machines = [];
                  } else {
                    state.machineSearchError = undefined;
                  }
            })

            .addCase(getMachinesForCustomer.pending, state => {
                state.loading = true;
                state.machinesOfCustomer = [];
                state.customerSearchError = undefined;
                state.pageData.totalRecords = 0;

            })
            .addCase(getMachinesForCustomer.rejected, (state, action) => {
                state.loading = false;
                state.customerSearchError = action.error;
                state.pageData.totalRecords = 0;
            })
            .addCase(getMachinesForCustomer.fulfilled, (state, action) => {
                state.loading = false;
                state.machinesOfCustomer = action.payload;
                /*Setting pagination data*/
                state.pageData.pageNumber = action.payload?.pageNumber;
                state.pageData.pageSize = action.payload?.pageSize;
                state.pageData.count = action.payload?.count;
                state.pageData.hasMore = action.payload?.hasMore;
                state.pageData.totalRecords = action.payload?.totalRecords;
                state.customerSearchError = undefined;
            })
            .addCase(getMachinesForDealer.pending, (state) => {
                state.loading = true;
                state.machinesOfDealer = [];
                state.dealerSearchError = undefined;
                state.pageData.totalRecords = 0;
            })
            .addCase(getMachinesForDealer.rejected, (state, action) => {
                state.loading = false;
                state.dealerSearchError = action.error;
                state.pageData.totalRecords = 0;
            })
            .addCase(getMachinesForDealer.fulfilled, (state, action) => {
                state.loading = false;
                state.machinesOfDealer = action.payload?.machines;
                /*Setting pagination data*/
                state.pageData.pageNumber = action.payload?.pageNumber;
                state.pageData.pageSize = action.payload?.pageSize;
                state.pageData.count = action.payload?.count;
                state.pageData.hasMore = action.payload?.hasMore;
                state.pageData.totalRecords = action.payload?.totalRecords;
                state.dealerSearchError = undefined;
            })
    }
})
export const {setSearchedPin, setDealerSearchData, resetMachineState, resetMachineDetails, resetMachineError } = machineListSlice.actions

export const machinesForDealer = state => state.machineSearchResult.machinesOfDealer;
export const machinesList = (state) => state.machineSearchResult.machines.machines;
export const pageSize = (state) => state.machineSearchResult.pageData.pageSize;
export const pageNumber = (state) => state.machineSearchResult.pageData.pageNumber;
export const hasMoreRecords = (state) => state.machineSearchResult.pageData.hasMore;
export const recordCount = (state) => state.machineSearchResult.pageData.count;
export const totalRecords = (state) => state.machineSearchResult.pageData.totalRecords;
export const dealerSearchData = (state) => state.machineSearchResult.dealerSearchData;
export const machinesForCustomers = state => state.machineSearchResult.machinesOfCustomer.machines;
export const machineListLoading = (state) => state.machineSearchResult.loading;
export const machineListError = (state) => state.machineSearchResult.machineSearchError;
export const dealerMachineListError = state => state.machineSearchResult.dealerSearchError;
export const customerMachineListError = state => state.customerSearchError;
export const machineDetails = (state) => state.machineSearchResult.machine;


export const searchedPin = (state) => state.machineSearchResult.searchedPin;

export default machineListSlice.reducer;